import { FieldProps } from 'formik';
import { ReactElement, useMemo } from 'react';
import DeclarationField from 'views/declarations/common/DeclarationField';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import { useTranslation } from 'react-i18next';
import FormSelect from '../../../../../components/ui/composed/declarations/formSelect/DeclarationSelect';
import { ValidationSchema, validators } from '../validations/validations';
import HideComponent from '../../../../../utils/HideComponent';
import useCodelists from '../../../../../hooks/useCodelists';

type Fields = 'paymentMethodCode';

export const transportChargesMethodOfPaymentBlockValidation: {
    childValidators: {
        'consignment.freight': ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        'consignment.freight': {
            childValidators: {
                paymentMethodCode: [validators.exact(1)],
            },
        },
    },
};

export const consignmentItemsBlockValidation: {
    childValidators: {
        'consignment.consignmentItem': ValidationSchema<'freight'>;
    };
} = {
    childValidators: {
        'consignment.consignmentItem': {
            childValidators: {
                freight: {
                    childValidators: {
                        paymentMethodCode: [validators.exact(1)],
                    },
                },
            },
        },
    },
};

interface Props extends BlockProps<Fields> {
    isProduct?: boolean;
}

const TransportChargesMethodOfPaymentBlock = ({
    path = 'consignment.freight',
    isProduct = false,
    hide,
}: Props): ReactElement => {
    const { t } = useTranslation('form');
    const { cdsCodelists } = useCodelists();

    const ucc = useMemo(() => '4/2', []);
    return (
        <HideComponent hide={hide}>
            <DeclarationField name="paymentMethodCode" pathPrefix={path}>
                {({ form, field }: FieldProps<any>) => (
                    <FormSelect
                        refNumber={ucc}
                        label={t('transportChargesMethodOfPayment' + (isProduct ? 'Products' : ''))}
                        {...getFormikProps(field.name, form)}
                        selectOptions={cdsCodelists?.transportPaymentMethodTypes}
                        condensed
                        codeValidation={[validators.exact(1)]}
                    />
                )}
            </DeclarationField>
        </HideComponent>
    );
};

export default TransportChargesMethodOfPaymentBlock;
